import { handleEvent } from "./user-events";

interface HeadwayWidget {
    getUnseenCount: () => number;
}

interface HeadwayConfig {
    selector: string;
    account: string;
    trigger?: string;
    callbacks?: {
        onShowWidget?: () => void;
        onHideWidget?: () => void;
        onWidgetReady?: (widget: HeadwayWidget) => void;
        onShowDetails?: (changelog: {
            position: number;
            id: string;
            title: string;
            category: string;
        }) => void;
        onReadMore?: (changelog: {
            position: number;
            id: string;
            title: string;
            category: string;
        }) => void;
    };
}

interface HeadwayGlobal {
    init: (config: HeadwayConfig) => void;
    show: () => void;
}

declare const Headway: HeadwayGlobal | undefined;

type UpdatesConfigType = "default" | "sidebar";

const ACCOUNT_ID = "x9p4My";
const MAX_ATTEMPTS = 60;
const RETRY_DELAY = 1000;

const configMap: Record<UpdatesConfigType, HeadwayConfig> = {
    default: {
        selector: "#product-updates",
        account: ACCOUNT_ID,
        callbacks: {
            onShowWidget: () => {
                handleEvent("open-feature-announcements");
            },
        },
    },
    sidebar: {
        selector: "#sidebar-product-updates-badge",
        account: ACCOUNT_ID,
        trigger: "#sidebar-announcements-trigger",
        callbacks: {
            onShowWidget: () => {
                handleEvent("open-feature-announcements");
            },
        },
    },
};

const attemptCounters: Record<UpdatesConfigType, number> = {
    default: 0,
    sidebar: 0,
};

const initializeHeadway = (configType: UpdatesConfigType) => {
    if (typeof Headway === "undefined" || !Headway) {
        attemptCounters[configType]++;

        if (attemptCounters[configType] <= MAX_ATTEMPTS) {
            setTimeout(() => initializeHeadway(configType), RETRY_DELAY);
        } else {
            console.warn(
                `Headway failed to initialize after ${MAX_ATTEMPTS} attempts for config: ${configType}`,
            );
        }
    } else {
        Headway.init(configMap[configType]);
    }
};

export const initializeUpdates = () => {
    initializeHeadway("default");
};

export const initializeSidebarUpdates = () => {
    initializeHeadway("sidebar");
};

export const getUnseenCount = (): number => {
    if (typeof Headway === "undefined" || !Headway) {
        return 0;
    }

    try {
        const badge = document.querySelector(
            '#sidebar-product-updates-badge span[id="HW_badge"]',
        );
        if (badge && badge.textContent) {
            const count = parseInt(badge.textContent, 10);
            return isNaN(count) ? 0 : count;
        }
    } catch (error) {
        console.warn("Error getting Headway unseen count:", error);
    }

    return 0;
};
